import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import '../../../css/Style/SingleTrip/Gallery.css';

import { Modal, Button } from 'react-bootstrap';
// import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper.min.css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// SwiperCore.use([Navigation, Pagination]);

const Accomodation = ({ trip }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [imageUrls, setImageUrls] = useState([]);
    const arrowRef = useRef();

    useEffect(() => {
        // Extract the URLs from the trip.gallery data and store them in the imageUrls array
        const urls = trip?.accomodation?.map((item) => item?.url);
        setImageUrls(urls);
    }, [trip?.accomodation]);

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4.5,
        slidesToScroll: 1,
        initialSlide: 0,
        rows: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.8,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.7,
                    slidesToScroll: 1,
                    dots: false
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    dots: false
                }
            }
        ]
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleImageClick = (index) => {
        if(trip){
            setSelectedImageIndex(index);
        }
        handleOpenModal();
    };
    return (
        <div className='my-5 video__cont'>
            <div>
                {
                    trip?.accomodation?.length > 0 &&
                    <>
                        <h2 className='Mon_font'>Accomodation</h2>
                        <div className='hr-line-head'>
                            <div className="hr-line m-0 mb-3 "></div>
                        </div>
                    </>
                }
                <div className="img__gallery">
                    <Slider ref={arrowRef} {...settings}>
                        {
                            trip?.accomodation?.map((item, index) => {
                                return (
                                    <img src={item.url} alt="" className='m-3' width={200} onClick={() => handleImageClick(index)} />
                                )
                            })
                        }
                    </Slider>
                    {
                        trip?.accomodation?.length >= 4 &&
                        <div>
                            <button onClick={() => arrowRef.current.slickPrev()} className='arrow__left'><i className="fa-solid fa-chevron-left"></i></button>
                            <button onClick={() => arrowRef.current.slickNext()} className='arrow__right'><i className="fa-solid fa-chevron-right"></i></button>
                        </div>
                    }
                    <div className='d-flex justify-content-center align-items-center accomodation-notes-parent'>
                        <p className='accomodation-notes Mon_font'><strong><em>Note:- </em></strong><em><small className='text-secondary'>The accommodation we provide will either be the one shown or a similar, carefully selected option. We choose each stay with care after thorough quality checks to make sure you have a great experience!</small></em></p>
                    </div>
                </div>
                
                <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
                    <Modal.Body>
                        {trip &&
                        <div>
                            <img src={imageUrls && imageUrls[selectedImageIndex]} alt={`Image ${selectedImageIndex + 1}`} style={{ width: '100%', height: 'auto' }}/>
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}

export default Accomodation
